import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={200}
    height={200}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path fill="currentColor" d="M0 0h62.26v330.035H0z" />
    <path
      fill="currentColor"
      d="M328.909 0v62.464H0V0zM1024 0v62.464H695.091V0z"
    />
    <path
      fill="currentColor"
      d="M1024 330.035h-62.26V0H1024zm0 693.965h-62.26V693.965H1024z"
    />
    <path
      fill="currentColor"
      d="M695.091 1024v-62.464H1024V1024zM0 1024v-62.464h328.909V1024z"
    />
    <path
      fill="currentColor"
      d="M0 693.965h62.26V1024H0zm430.643-162.816h62.26v286.31h-62.26zM207.565 206.54v286.31h285.337v-286.31zM433.97 433.715H266.547V265.728h167.424zm97.127 97.434v286.31h285.337V531.15zm226.355 227.123H590.029V590.285h167.424zM207.565 704.41h112.691v113.05H207.565zm0-173.261h112.691v113.05H207.565zM754.176 206.54h62.26v286.31h-62.26zM531.098 379.8h112.69v113.05h-112.69zm0-173.26h112.69v113.05h-112.69z"
    />
  </svg>
);
export default SvgComponent;
